export enum ContentConfigOptionType {
    text = 'text',
    number = 'number',
    boolean = 'boolean',
    select = 'select'
  }